<template>
  <v-card v-if="$store.getters.currentMerchant">
    <v-card-title>
      <span>
        {{
          $store.getters.merchantDelegationIsEdit
            ? 'ویرایش نمایندگی '
            : 'ایجاد نمایندگی '
        }}</span
      >
    </v-card-title>
    <v-divider> </v-divider>
    <v-card-text>
      <v-form ref="merchantDelegationForm" v-model="merchantDelegationValid">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              required
              :rules="[(v) => !!v || 'وارد کردن عنوان الزامی میباشد']"
              label="عنوان"
              v-model="merchantDelegation.title"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              label="استان *"
              required
              :rules="[(v) => !!v || 'وارد کردن استان الزامی میباشد']"
              v-model="merchantDelegation.stateId"
              outlined
              item-text="value"
              item-value="id"
              dense
              :items="provinceList"
              @change="getCitys()"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              required
              :rules="[(v) => !!v || 'وارد کردن شهرستان الزامی میباشد']"
              label="شهرستان"
              hint="ابتدا استان را انتخاب کنید"
              persistent-hint
              v-model="merchantDelegation.cityId"
              outlined
              item-text="value"
              item-value="id"
              dense
              :items="cityList"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              required
              :rules="[(v) => !!v || 'وارد کردن آدرس الزامی میباشد']"
              label="آدرس"
              v-model="merchantDelegation.address"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-textarea
              label="درباره نمایندگی"
              outlined
              dense
              v-model="merchantDelegation.about"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6">
            <v-combobox
              deletable-chips
              v-model="merchantDelegation.responsiblePeople"
              hide-selected
              label="افراد مسئول "
              multiple
              persistent-hint
              small-chips
              outlined
              dense
              clearable
              flat
              hide-no-data
            >
            </v-combobox>
          </v-col>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>شماره های تماس</v-card-title>
              <v-card-text>
                <div
                  cols="12"
                  class="py-0"
                  v-for="(phone, index) in merchantDelegation.phones"
                  :key="index"
                >
                  <v-row>
                    <v-col cols="1" class="py-0">
                      <v-btn icon color="error" @click="removePhone(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        label="* عنوان"
                        required
                        :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                        outlined
                        dense
                        v-model="phone.title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        label="نوع *"
                        required
                        :rules="[(v) => !!v || 'وارد کردن نوع الزامی میباشد']"
                        v-model="phone.type"
                        outlined
                        item-value="title"
                        item-text="displayName"
                        dense
                        :items="phoneTypeList"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        label="شماره تلفن *"
                        outlined
                        required
                        :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                        dense
                        type="number"
                        v-model="phone.phoneNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-tooltip right @click="addListPhone()">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="addListPhone()"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-plus-circle </v-icon>
                    </v-btn>
                  </template>
                  <span> افزودن</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <label for="">انتخاب موقعیت جغرافیایی</label>
            <l-map
              ref="myMap"
              :zoom="zoom"
              :center="center"
              style="width: 100%; height: 300px"
              @click="addMarkerAddr"
              @fullscreenchange="handleFullScreenChange"
              @update:center="centerUpdated"
            >
              <l-control-fullscreen
                position="topleft"
                :options="{
                  title: { false: 'Go big!', true: 'Be regular' },
                }"
              />
              <l-tile-layer :url="url" />
              <l-marker
                v-for="(item, index) in marker"
                :key="index"
                :lat-lng="item"
              >
                <l-icon
                  :icon-size="[40, 40]"
                  :icon-anchor="[20, 40]"
                  :icon-url="path"
                >
                </l-icon>
              </l-marker>
            </l-map>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="closeForm()"> انصراف </v-btn>
      <v-btn @click="createOrEditmMerchantDelegation()" color="primary">
        ذخیره
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const merchantDelegationsRepository = RepoFactory.get('merchantDelegations');
const merchantRepository = () => RepoFactory.get('merchant');
const enumsRepository = () => RepoFactory.get('enums');
import Helper from '@/core/helpers';
export default {
  data() {
    return {
      merchantDelegationValid: true,
      merchantDelegation: {
        merchantId: null,
        title: null,
        stateId: null,
        cityId: null,
        address: null,
        about: null,
        phones: [
          {
            title: null,
            type: '',
            phoneNumber: '',
          },
        ],
        responsiblePeople: [],
        latitude: null,
        longitude: null,
        delegationMerchantId: null,
      },
      provinceList: [],
      cityList: [],
      phoneTypeList: [],
      zoom: 5,
      path: '/media/map/pin.svg',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      marker: [],
      center: { lat: 35.738018, lng: 51.404314 },
    };
  },
  created() {
    this.getProvinceList();
    this.getPhoneTypeList();
    this.currentLocationButton();
    if (this.$store.getters.merchantDelegationIsEdit) {
      this.fillInput(this.$store.getters.merchantDelegationSelectedForEdit);
    }
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  beforeDestroy() {
    this.$store.commit('setMerchantDelegationSelectedForEdit', null);
    this.$store.commit('setMerchantDelegationIsEdit', false);
    this.$store.commit('setMerchantDelegationFormStatus', false);
    this.$refs.merchantDelegationForm.reset();
  },
  methods: {
    centerUpdated(event) {
      this.center = event;
    },
    handleFullScreenChange() {
      this.$refs.myMap.mapObject.panTo([
        this.merchantDelegation.latitude,
        this.merchantDelegation.longitude,
      ]);
    },
    addMarkerAddr(event) {
      this.merchantDelegation.latitude = event.latlng.lat;
      this.merchantDelegation.longitude = event.latlng.lng;
      this.marker = [];
      this.marker.push(event.latlng);
    },
    addListPhone() {
      this.merchantDelegation.phones.push({
        title: null,
        type: '',
        phoneNumber: '',
      });
    },
    removePhone(index) {
      this.merchantDelegation.phones.splice(index, 1);
    },
    getPhoneTypeList() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('PhoneType', this.merchantBaseUrl)
        .then(({ data }) => {
          this.phoneTypeList = data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getProvinceList() {
      const loader = this.$loading.show();
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.provinceList = res.data;
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getCitys() {
      const loader = this.$loading.show();
      if (
        !this.$store.getters.merchantDelegationSelectedForEdit ||
        (this.$store.getters.merchantDelegationSelectedForEdit &&
          this.merchantDelegation.stateId !=
            this.$store.getters.merchantDelegationSelectedForEdit.stateId)
      ) {
        this.merchantDelegation.cityId = null;
      }
      const params = {
        stateId: this.merchantDelegation.stateId,
        cityType: 'City',
      };
      merchantRepository()
        .getCitiesByState(this.merchantBaseUrl, params)
        .then((res) => {
          loader.hide();
          this.cityList = res.data;
        })
        .catch((err) => {
          loader.hide();
          Helper.handleErrors(err, this);
        });
    },
    fillInput(data) {
      if (data) {
        this.merchantDelegation.title = data.title;
        this.merchantDelegation.about = data.about;
        this.merchantDelegation.address = data.address;
        this.merchantDelegation.cityId = data.cityId;
        this.merchantDelegation.delegationMerchantId =
          data.delegationMerchantId;
        this.merchantDelegation.phones = data.phones;
        this.merchantDelegation.responsiblePeople = data.responsiblePeople;
        this.merchantDelegation.stateId = data.stateId;
        this.merchantDelegation.latitude = data.latitude;
        this.merchantDelegation.longitude = data.longitude;
        if (data.latitude && data.longitude) {
          let latlng = {
            lat: data.latitude,
            lng: data.longitude,
          };
          this.marker.push(latlng);
          this.center = [data.latitude, data.longitude];
        }
        this.getCitys();
      }
    },
    currentLocationButton() {
      let app = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          app.marker = [];
          let latlng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          app.merchantDelegation.latitude = position.coords.latitude;
          app.merchantDelegation.longitude = position.coords.longitude;
          app.marker.push(latlng);
          app.$refs.myMap.mapObject.flyTo(latlng, 15);
        });
      } else {
        alert('موقعیت یاب در این مرورگر پشتیبانی نمیشود');
      }
    },
    closeForm() {
      this.$store.commit('setMerchantDelegationSelectedForEdit', null);
      this.$store.commit('setMerchantDelegationIsEdit', false);
      this.$store.commit('setMerchantDelegationFormStatus', false);
    },
    createOrEditmMerchantDelegation() {
      if (this.$refs.merchantDelegationForm.validate()) {
        const loader = this.$loading.show();

        if (this.$store.getters.merchantDelegationIsEdit) {
          this.merchantDelegation.merchantId = this.merchantId
          merchantDelegationsRepository
            .editMerchantDelegation(
              this.$store.getters.merchantDelegationSelectedForEdit.id,
              this.merchantDelegation,
              this.merchantBaseUrl,
              { MerchantId: this.merchantId }
            )
            .then((data) => {
              this.closeForm();
              loader.hide();
              this.$dialog.message.success('با موفقیت ثبت گردید', {
                position: 'top-left',
              });
            })
            .catch((error) => {
              loader.hide();
              Helper.handleErrors(error, this);
            });
        } else {
          this.merchantDelegation.merchantId = this.merchantId;
          merchantDelegationsRepository
            .createMerchantDelegation(
              this.merchantDelegation,
              this.merchantBaseUrl,
              {
                MerchantId: this.merchantId,
              }
            )
            .then((data) => {
              this.closeForm();
              this.$dialog.message.success('با موفقیت ثبت گردید', {
                position: 'top-left',
              });
              loader.hide();
            })
            .catch((error) => {
              loader.hide();
              Helper.handleErrors(error, this);
            });
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-item-title {
  cursor: pointer;
  &:hover {
    transition: 300ms ease-in-out;
    color: darkblue;
  }
}
</style>
